//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Chart from '../../general/Chart';
export default {
  name: 'MeasurementDetailChart',
  components: {
    Chart: Chart
  },
  props: {
    data: {
      type: Array,
      default: null
    },
    person: {
      type: Object,
      default: null
    }
  },
  computed: {
    setDefinitions: function setDefinitions() {
      return [{
        title: t('health', 'Temperature', {}),
        columnId: 'temperature',
        timeId: 'datetime',
        valueId: 'temperature',
        getValueY: function getValueY(v) {
          return v;
        },
        borderColor: 'darkblue',
        borderWidth: 2,
        fill: true,
        show: 'measurementColumnTemperature' in this.person && this.person.measurementColumnTemperature
      }, {
        title: t('health', 'Heart rate', {}),
        columnId: 'heartRate',
        timeId: 'datetime',
        valueId: 'heartRate',
        getValueY: function getValueY(v) {
          return v;
        },
        borderColor: 'darkgreen',
        borderWidth: 2,
        fill: false,
        show: 'measurementColumnHeartRate' in this.person && this.person.measurementColumnHeartRate
      }, {
        title: t('health', 'Blood pressure systolic', {}),
        columnId: 'bloodPressureS',
        timeId: 'datetime',
        valueId: 'bloodPressureS',
        getValueY: function getValueY(v) {
          return v;
        },
        borderColor: 'rgb(110,20,128)',
        borderWidth: 2,
        fill: false,
        show: 'measurementColumnBloodPres' in this.person && this.person.measurementColumnBloodPres
      }, {
        title: t('health', 'Blood pressure diastolic', {}),
        columnId: 'bloodPressureD',
        timeId: 'datetime',
        valueId: 'bloodPressureD',
        getValueY: function getValueY(v) {
          return v;
        },
        borderColor: 'rgb(188,4,219)',
        borderWidth: 2,
        fill: false,
        show: 'measurementColumnBloodPres' in this.person && this.person.measurementColumnBloodPres
      }, {
        title: t('health', 'Oxygen saturation', {}),
        columnId: 'oxygenSat',
        timeId: 'datetime',
        valueId: 'oxygenSat',
        getValueY: function getValueY(v) {
          return v;
        },
        borderColor: 'rgb(12,147,159)',
        borderWidth: 2,
        fill: true,
        show: 'measurementColumnOxygenSat' in this.person && this.person.measurementColumnOxygenSat
      }, {
        title: t('health', 'Blood sugar', {}),
        columnId: 'bloodSugar',
        timeId: 'datetime',
        valueId: 'bloodSugar',
        getValueY: function getValueY(v) {
          return v;
        },
        borderColor: 'rgb(181,80,17)',
        borderWidth: 2,
        fill: true,
        show: 'measurementColumnBloodSugar' in this.person && this.person.measurementColumnBloodSugar
      }, {
        title: t('health', 'Defecation', {}),
        columnId: 'defecation',
        timeId: 'datetime',
        valueId: 'defecation',
        getValueY: function getValueY(v) {
          var maxIndex = 3;
          return Math.round((v + 1) / (maxIndex + 1) * 100);
        },
        borderColor: 'darkgray',
        borderWidth: 2,
        fill: true,
        type: 'bar',
        show: 'measurementColumnDefecation' in this.person && this.person.measurementColumnDefecation
      }];
    },
    options: function options() {
      return {
        title: {
          text: t('health', 'Chart')
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            type: 'time',
            time: {
              minUnit: 'hour'
            }
          }],
          yAxes: [{
            gridLines: {
              display: true,
              color: 'gray',
              z: 100,
              lineWidth: 1
            },
            scaleLabel: {
              display: true,
              labelString: t('health', 'Values')
            },
            min: 0,
            max: 100
          }]
        },
        tooltips: {
          enabled: true
        },
        layout: {
          padding: {
            right: 30,
            left: 25
          }
        },
        legend: {
          position: 'bottom'
        }
      };
    },
    chartStyle: function chartStyle() {
      return {
        height: '250px'
      };
    }
  }
};